module.exports = __webpack_public_path__ + "static/img/icon-3.196f00e0.png";